import { ManualTitle } from '../../component/ManualTitle';
import ManualPageList from '../../component/ManualPageList';
import ManualCategoryMaintenancePlan from '../../component/ManualCategoryMaintenancePlan';
import ManualModalBill from '../../component/ManualModalbill';

export const ManualMaintenancePlan008: React.FC = () => {
  return (
    <>
      <ManualTitle
        id="manual-008"
        SubTitle={['どこでも', <br key="key" />, 'メンテナンスプラン']}
      ></ManualTitle>
      <ManualCategoryMaintenancePlan id="manual-008"></ManualCategoryMaintenancePlan>
      <section className="section-common">
        <div className="container">
          <h3
            className="common-category-header has-text-weight-bold has-text-centered"
            id="about"
          >
            どこでもメンテナンスプラン
            <br />
            について
          </h3>
          <h4 className="common-section-header has-text-centered has-text-weight-bold">
            どこでもメンテナンスプランでできること
          </h4>
          <div className="inner">
            <h5 className="common-text-header has-text-weight-bold">
              車検などのメンテナンス
            </h5>
            <p className="is-margin-top-7">
              お客様のお好きな整備業者にて点検実施後、お支払いいただいた車検代や法定12ヶ月点検料の他、お車のメンテナンス時に発生した費用を、上限回数・金額内でキャッシュバックいたします。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>延長保証</p>
            </h5>
            <p className="is-margin-top-7">
            メーカー保証が終了した後に、同程度の保証を提供いたします。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>無償譲渡</p>
            </h5>
            <p className="is-margin-top-7">
            ご契約満了後にお車を無償譲渡いたします。
            </p>
            <a
              href="https://carmo-kun.jp/docs/maintenance/new/dokodemo_maintenance_v1.pdf"
              className="is-margin-top-7 button-base-arrow has-text-weight-bold has-text-black button-orange"
            >
              メンテナンスプラン<br />サービス資料はこちら
            </a>
            <p className="common-back-category has-text-right is-margin-top-7 has-text-border">
              <a href="#category" className="has-text-black">
                カテゴリ選択に戻る
              </a>
            </p>
          </div>
          <h3
            className="common-category-header has-text-weight-bold has-text-centered"
            id="invoice"
          >
            メンテナンス請求について
          </h3>
          <h4 className="common-section-header has-text-centered has-text-weight-bold is-margin-top-7">
            ご請求の流れ
          </h4>
          <div className="inner">
            <ul className="common-step is-margin-top-4">
              <li className="is-flex is-mobile">
                <p className="common-step-flow">
                  点検・消耗品
                  <br />
                  交換実施
                </p>
                <div className="common-step-text">
                  お客様のご都合の良い整備業者にてご予約のうえ、点検や消耗品の交換をお受けください。
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">
                  明細書の
                  <br />
                  お受け取り
                </p>
                <div className="common-step-text">
                  <p>
                    整備業者にて下記を満たした明細書(納品請求書やレシート等)をお受取りください。
                  </p>
                  <div className="text-border-box">
                    <ul className="has-text-weight-bold">
                      <li>・点検実施日・整備工場名</li>
                      <li>・ご請求対象項目と項目ごとの料金</li>
                    </ul>
                    <p>
                      ※上記が手書きの場合は社判入り領収証もご用意ください。
                    </p>
                  </div>
                  <p className="is-margin-top-7">
                    請求対象項目をご確認のうえ、点検実施30日以内にご請求ください。
                  </p>
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">明細書の撮影</p>
                <div className="common-step-text">
                  <p>
                  撮影した画像を添付し、ご契約者様専用アプリ、もしくはメールにてご請求いただきます。
                  </p>
                  <ManualModalBill></ManualModalBill>
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">ご請求</p>
                <div className="common-step-text">
                  <p>
                    撮影した画像を添付し、ご契約者様専用アプリにてご請求いただきます。
                  </p>
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">内容確認</p>
                <div className="common-step-text">
                  <p>
                  カーリースカルモくんサポートデスクにて、請求内容を確認いたします。
                  </p>
                  <p className="is-margin-top-4">
                  ※明細書画像の不備や、ご請求項目漏れなどがあった場合、再請求をお願いすることがございます。再請求内容を確認のうえ受領となりますので予めご了承ください。
                  </p>
                </div>
              </li>
              <li className="is-flex is-mobile">
                <p className="common-step-flow">お振り込み</p>
                <div className="common-step-text">
                  <p className="has-text-weight-bold">
                    締め日は毎週土曜日・月曜日の週2回です。請求内容に不備がなければ、締め日から4営業日後にお振り込みいたします。
                  </p>
                  <p className="is-margin-top-4">
                    ※再請求ご依頼中や、
                    <span className="has-text-weight-bold">
                      カーライフサポート料のお支払い確認が取れていない場合、確認が取れてからのお振り込みとなります
                    </span>
                    ので予めご了承ください。
                  </p>
                </div>
              </li>
            </ul>
            <a
              href={process.env.REACT_APP_MAINT_REQUEST_URL}
              className="button-base-arrow has-text-weight-bold has-text-black is-margin-top-7"
            >
              メンテナンス請求をする
            </a>
            <p className="is-size-5 has-text-centered">
              ※会員様専用サイトへのログインが必要となります。
            </p>
          </div>
          <h4 className="common-section-header has-text-centered has-text-weight-bold is-margin-top-7">
          メールでのご請求方法
          </h4>
          <div className="inner">
            <p>1.お電話もしくはメールにて「どこでもメンテナンスプランのご請求」とお申し出<br />
            2.メールにて「ご請求フォーマット」を送付<br />
            3.実施日を入力<br />
            4.ご契約者のお名前、電話番号、ご住所をご入力<br />
            5.ご請求対象項目を確認のうえ、品目、金額をご入力<br />
            6.明細書の画像を撮影、もしくは事前に撮影した画像を添付し送信</p>
            <p className="is-margin-top-7">
              超過した分はお客様ご負担となりますため、相見積もりなどをお取りいただき、ご負担の少ない整備業者にて行なっていただくことをおすすめいたします。
            </p>
            <h5 className="common-text-header has-text-weight-bold has-text-border">
              <p>ご請求フォーマット例</p>
            </h5>
            <p className="border-box is-margin-top-7">=====請求書=====<br />
              請求先:ナイル株式会社<br />
              メンテナンス実施日:2023/1/20<br />
              お名前フルネーム:苅藻太郎様<br />
              ご登録のお電話番号:090XXXXXXXX<br />
              ご登録の住所:東京都品川区東五反田1-24-2 東五反田1丁目ビル7F<br />
              品目:法定12ヶ月点検<br />
              利用金額:10,600円(税込)<br />
              請求金額:10,190円(税込)<br />
              品目:エンジンオイル交換<br />
              利用金額:4,980円(税込)<br />
              請求金額:4,980円(税込)<br />
              --------------------<br />
              ・引き落とし口座へ振り込みお願いいたします。<br />
              ・振込手数料は御社ご負担にてお願いいたします。</p>
          </div>
        </div>
      </section>
      <ManualPageList id="manual-008"></ManualPageList>
    </>
  );
};
